/**
 * Given a list of items, reorganize them into a list of lists
 * where each top-level list represents a row; and the interior list
 * is a list of at most 4 items which prepresents the ordered colum
 *
 * e.g. [1 ... 16] -> [[1, 5, 9, 13], [2, 6, 10, 14], [3, 7, 11, 15], [4, 8, 12, 16]]
 * [1 ... 10] -> [[1, 4, 7, 10], [2, 5, 8, undefined], [3, 6, 9, undefined]]
 * @param input list of input to munge
 * @param numCols the total number of coumns to attempt to divide the input into
 */
export const arrayToRows = <T>(input: T[], numCols = 4): Array<Array<T>> => {
    let outRows = [];

    let numRows = Math.ceil(input.length / numCols);

    for (let curRow = 0; curRow < numRows; curRow++) {
        let curCols = [];

        for (let curCol = 0; curCol < numCols; curCol++) {
            let curVal = input[curCol * numRows + curRow];
            curCols.push(curVal);
        }
        outRows.push(curCols);
    }

    return outRows;
};

// TODO actually this function is already in modern browser, Object.fromEntries, but typescript doesnt support it yet.
// Remove this function after typescript/webpack will have native support with polyfill for old browser
export const fromEntries = <T>(iterable: [string, T][]): { [index: string]: T } => {
    return [...iterable].reduce((obj, [key, val]) => {
        obj[key] = val;
        return obj;
    }, {});
};

/**
 * Given array or item or null and always return array
 * take    |  return
 * item    => [item]
 * [items] => [items]
 * null    => []
 * @param item arrat or item or null
 */

export const asArray = <T>(item: T | T[] | null | undefined) => {
    if (!item) {
        return [];
    }
    if (Array.isArray(item)) {
        return item;
    }
    return [item];
};
